export default "__VITE_ASSET__ZTCMa9Bt__"